
// src/features/alerts/AlertsModule.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AlertsList from './AlertsList';

/**
 * Módulo de Alertas (Vencimientos)
 * Maneja las rutas y componentes para el módulo de Alertas
 */
function AlertsModule() {
  return (
    <Routes>
      {/* Ruta base: muestra la lista de vencimientos */}
      <Route index element={<AlertsList />} />
    </Routes>
  );
}

export default AlertsModule;